export default "__VITE_ASSET__Cy$e8cAt__"